/**
 * Domínio: plantão vencido — GUPM-273.
 *
 * 12 h sem passagem é regra de operação, não detalhe de tela: o plantonista que
 * passa disso deixou de ser rendido e a operação precisa enxergar isso.
 *
 * `now` é parâmetro de propósito — função que lê o relógio por dentro não é
 * testável sem congelar tempo.
 *
 * TS puro: sem React, sem Supabase, sem DOM.
 */

/** Limiar padrão, em horas, para considerar um plantão vencido. */
export const SHIFT_STALE_HOURS = 12;

/**
 * O plantão iniciado em `since` está vencido em `now`?
 *
 * O limiar é inclusivo: exatamente 12 h já conta como vencido. Duração negativa
 * (relógio do cliente atrás do início) nunca vence — não é motivo de alarme.
 */
export function isShiftStale(
  since: Date,
  now: Date,
  thresholdHours: number = SHIFT_STALE_HOURS,
): boolean {
  const horas = (now.getTime() - since.getTime()) / 3_600_000;
  // `>=` e não `>`: o limiar É o vencimento. E duração negativa (relógio do
  // cliente atrás do início) nunca acende alarme — o problema aí é o relógio.
  return horas >= thresholdHours;
}
